import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DefaultDataServiceConfig, HttpUrlGenerator, HttpOptions } from '@ngrx/data';
import { Store } from '@ngrx/store';
import moment from 'moment';
import { Observable } from 'rxjs';
import { map, tap, catchError } from 'rxjs/operators';
import { LoggingService } from '../../shared/services/logging/logging.service';
import { EfaactDataService } from '../efaact.data-service';
import { RateCeiling } from './rate-ceiling.model';
import * as fromShared from '../../shared';
import { environment } from '../../../environments/environment';

// Add this constant if it's not already defined
const DisplayMessageMinimum = 300; // Adjust this value based on your application's needs

export const entityName = 'ContractRateCeiling';

@Injectable()
export class RateCeilingDataService extends EfaactDataService<RateCeiling> {
    constructor(
        http: HttpClient,
        httpUrlGenerator: HttpUrlGenerator,
        log: LoggingService,
        config: DefaultDataServiceConfig,
        store: Store
    ) {
        super(http, httpUrlGenerator, entityName, log, config, store);
    }

    getAll(): Observable<RateCeiling[]> {
        return this.getWithQuery({ activeOnly: true });
    }

    getWithQuery(params: string | { [key: string]: any }): Observable<RateCeiling[]> {
        this.log.verbose({
            type: 'RateCeilingDataService:getWithQuery',
            params: params
        });

        // Only handle activeOnly requests with GET endpoint
        if (typeof params === 'object' && 
            params !== null &&
            Object.keys(params).length === 1 && 
            'activeOnly' in params) {
            
            const activeOnly = params.activeOnly as boolean;
            const uri = `${environment.apiLocation}/contractrateceiling?activeOnly=${activeOnly}`;
            
            this.log.verbose({
                type: 'RateCeilingDataService:getWithQuery:activeOnly:GET',
                uri: uri
            });

            return this.http.get<Array<RateCeiling>>(uri).pipe(
                map(resp => this.mapGetResponse(resp)),
                map(items => items.map(p => this.mapItems(p))),
                tap(res =>
                    this.log.verbose({
                        type: 'RateCeilingDataService:getWithQuery:activeOnly:response',
                        res
                    })
                ),
                catchError((e, c) =>
                    fromShared.Errors.handleDataServiceError(this.store, e, c)
                )
            );
        }
        
        return super.getWithQuery(params);
    }

    public getAllWithActiveFilter(activeOnly: boolean): Observable<Array<RateCeiling>> {
        return this.getWithQuery({ activeOnly });
    }

    mapItems(item: RateCeiling): RateCeiling {
        if (!item) {
            return;
        }
        return {
            ...item,
            id: item.Rateceilingid,
            Startdate: moment(item.Startdate).isValid() ? moment(item.Startdate).toDate() : null,
            Enddate: moment(item.Enddate).isValid() ? moment(item.Enddate).toDate() : null
        };
    }
}
